import { DEFAULT_PRICE } from '../constants';
export function getPrice(_ref) {
  var _ref$price = _ref.price,
    price = _ref$price === void 0 ? DEFAULT_PRICE : _ref$price,
    pricePeriod = _ref.pricePeriod,
    partners = _ref.partners;
  if (partners) {
    switch (pricePeriod) {
      case 'day':
        {
          return price === null || price === void 0 ? void 0 : price.pricePartnersDayNds;
        }
      case 'hour':
        {
          return price === null || price === void 0 ? void 0 : price.pricePartnersHourNds;
        }
      case 'month':
      default:
        {
          return price === null || price === void 0 ? void 0 : price.pricePartnersMonthNds;
        }
    }
  }
  switch (pricePeriod) {
    case 'day':
      {
        return price === null || price === void 0 ? void 0 : price.priceDayNds;
      }
    case 'hour':
      {
        return price === null || price === void 0 ? void 0 : price.priceHourNds;
      }
    case 'month':
    default:
      {
        return price === null || price === void 0 ? void 0 : price.priceMonthNds;
      }
  }
}